import React, { Component } from 'react'
import Button from '../Buttons'
import ReactPaginate from 'react-paginate';
import Previous from './previous'
import Next from './next'
import { translate } from "react-translate"
import Scroll from 'react-scroll';

@translate("Pagination")
export default class Pagination extends Component {

  constructor(props) {
    super(props);
    this.handlePageClick = this.handlePageClick.bind(this)
  }

  handlePageClick(data) {
    let selected = data.selected
    this.props.onClickPageNumber(selected)
    var scroller = Scroll.scroller;
    scroller.scrollTo('ContainerPropiedades', {
      duration: 1500,
      delay: 100,
      smooth: true,
    })
  }

  componentWillMount(){
    window.scrollTo(0, 0)
  }

  render () {

    const {
      page,
      total_pages,
      total_results,
      next_page,
      prev_page,
      page_lenght,
      fromCant,
      loading,
      to,
			t
		 } = this.props

    if ((total_results > 0)) {
      return (
        <div className="pagination-container">
          <div className="pag-results hidden-xs">
            <small>{to} {t("de")} {total_results} {t("resultados")} </small>
          </div>
          <ReactPaginate
            previousLabel={(page === 1) ? '' : <Previous />}
            nextLabel={(page === total_pages) ? '' : <Next />}
            pageCount={total_pages}
            forcePage={page - 1}
            marginPagesDisplayed={0}
            pageRangeDisplayed={4}
            onPageChange={(data) => this.handlePageClick(data)}
            containerClassName={"pagination"}
            subContainerClassName={"pages pagination"}
            activeClassName={"active"} />
        </div>
      )
    }
    else{
      return (
        <div>
        </div>
      )
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/Pagination/index.js